/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Brand_Short_Name1Inputs */

const vi_sitesettings_brand_short_name1 = /** @type {(inputs: Sitesettings_Brand_Short_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên ngắn (header, logo)`)
};

/**

* @param {Sitesettings_Brand_Short_Name1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_brand_short_name1 = /** @type {((inputs?: Sitesettings_Brand_Short_Name1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Brand_Short_Name1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_brand_short_name1(inputs)
});
export { sitesettings_brand_short_name1 as "siteSettings_brand_short_name" }